import * as React from 'react';
import {
  Router,
  Route,
  Switch,
  RouteComponentProps,
  withRouter
} from 'react-router';
/* TODO: This might need fixing, according to react-hot-loader docs... */
import { hot } from 'react-hot-loader';
import { History } from 'history';
import { ScrollToTop } from './app/components/Utils/ScrollToTop';
import { SiteMeta } from './app/components/Utils/SiteMeta';
import { Layout } from './app/containers/Layout';
import { HomePage } from './app/containers/HomePage';
import { ForgotPasswordPage } from './app/containers/ForgotPasswordPage';
import { LoginPage } from './app/containers/LoginPage';
import { SignUpPage } from './app/containers/SignUpPage';
import { ResetPasswordPage } from './app/containers/ResetPasswordPage';
import { UserProfilePage } from './app/containers/UserProfilePage';
import { SubcategoryPage } from './app/containers/SubcategoryPage';
import { CategoryPage } from './app/containers/CategoryPage';
import { NotFoundPage } from './app/containers/NotFoundPage';
import { PrivacyPage } from './app/containers/PrivacyPage';
import { TermsPage } from './app/containers/TermsPage';
import { VideoPage } from './app/containers/VideoPage';
import { AboutUsPage } from './app/containers/AboutUsPage';
import { ContactUsPage } from './app/containers/ContactUsPage';
import { LoggedOutRoute } from './app/containers/Utils/LoggedOutRoute';
import { LoggedInRoute } from './app/containers/Utils/LoggedInRoute';
import { SearchPage } from './app/containers/SearchPage';
import { PremiumPage } from './app/containers/PremiumPage';

export interface AppProps {
  history: History;
  DevTools: React.ComponentClass<{}>;
}

const LayoutWithRouter = withRouter(Layout);

// render react DOM
export default hot(module)(({ history, DevTools }: AppProps) => (
  <Router history={history}>
    <Route
      render={(props: RouteComponentProps<{}>) => (
        <LayoutWithRouter {...props} DevTools={DevTools}>
          {/* Apply the default site meta */}
          <SiteMeta />
          <ScrollToTop />
          <Switch>
            <Route
              exact={true}
              path="/categories/:category/:subCategory"
              component={SubcategoryPage}
            />
            <Route
              exact={true}
              path="/categories/:category"
              component={CategoryPage}
            />
            <Route
              path="/:videoType(videos|featured)/:slug"
              component={VideoPage}
            />
            <Route exact={true} path="/search" component={SearchPage} />
            <Route exact={true} path="/" component={HomePage} />
            <Route
              exact={true}
              path="/login"
              component={LoggedOutRoute(LoginPage)}
            />
            <Route
              exact={true}
              path="/sign-up"
              component={LoggedOutRoute(SignUpPage)}
            />
            <Route
              exact={true}
              path="/forgot-password"
              component={LoggedOutRoute(ForgotPasswordPage)}
            />
            <Route
              exact={true}
              path="/password/reset/:token"
              component={LoggedOutRoute(ResetPasswordPage)}
            />
            <Route
              exact={true}
              path="/profile"
              component={LoggedInRoute(UserProfilePage)}
            />
            <Route exact={true} path="/terms" component={TermsPage} />
            <Route exact={true} path="/privacy" component={PrivacyPage} />
            <Route exact={true} path="/about" component={AboutUsPage} />
            <Route exact={true} path="/contact" component={ContactUsPage} />
            <Route exact={true} path="/premier" component={PremiumPage} />
            <Route component={NotFoundPage} />
          </Switch>
        </LayoutWithRouter>
      )}
    />
  </Router>
));



// WEBPACK FOOTER //
// ./src/App.tsx